const { VUE_APP_TEARY_BACKEND_API_URL } = process.env;
const apiUrl = VUE_APP_TEARY_BACKEND_API_URL;

type Options = {
  custom: object;
  method: string;
  withToken: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fetchApi(vm: any) {
  const ret = async (endpoint = '', options: Options) => {
    const custom = options.custom || {};
    const method = options.method || 'GET';
    const withToken = options.withToken || false;
    let headers = new Headers();

    if (withToken) {
      const token = vm.$cookies.get('token');

      if (token) {
        headers = new Headers({
          Authorization: `${token.type} ${token.value}`,
          'Content-Type': 'application/json',
        });
      }
    }

    const req = await fetch(apiUrl + endpoint, {
      ...custom,
      headers,
      method,
    });
    let res;

    try {
      res = await req.json();
    } catch {
      res = null;
    }

    return res;
  };

  return ret;
}

export default {
  fetchApi,
};
